import { createFormContext } from "@mantine/form";

export const [CreateFormProvider, useCreateFormContext, useCreateForm] = createFormContext();
